<template>
<div class='container'>
  <img src="../assets/img/kefu.png" alt=""  @click="show=!show" >
  <img  src="../assets/img/kefu_qrcode.png"  class="qrcode" v-show="show" alt="">
</div>
</template>

<script>
export default {
    data(){
        return{
            show:false,
        }
    }
}
</script>

<style scoped>
 .container{
    position: fixed;
    right: 20px;
    top: 70%;
    z-index: 999;
 }
 .container img{
    width: 100px;
    height: 100px;
    display: block;
     cursor:pointer;
 }
 .container .qrcode{
    position: fixed;
    right: 130px;
    top: 70%;
    width: 100px;
    height: auto;
 }
</style>


// WEBPACK FOOTER //
// src/components/contact_us.vue